



















































































































































































































































































import { Component, Vue, Prop, Watch, Provide, Ref, PropSync } from 'vue-property-decorator';
import DocumentPage from '../Shared/DocumentPage.vue';
import OrderLine, { isLineEmpty } from './OrderLine.vue';
import CustomerInfo from '../Shared/CustomerInfo.vue';
import SupplierInfo from '../Shared/SupplierInfo.vue';
import OrderInfo from './OrderInfo.vue';
import DocumentDelivery from '../Shared/DocumentDelivery.vue';
import DocumentHeader, { DocumentShowType } from '../Shared/DocumentHeader.vue';
import DocumentLogo from '../Shared/DocumentLogo.vue';
import LineHeader from '../Shared/LineHeader.vue';
import OrderLineExtension from './OrderLineExtension.vue';
import OrderAllowanceCharges from './OrderAllowanceCharges.vue';
import DocumentFooter from '../Shared/DocumentFooter.vue';
import OrderSummary from './OrderSummary.vue';
import CreditNoteInvoicePicker from './CreditNoteInvoicePicker.vue';
import SForm from '@/components/UI/Form/SForm.vue';
import { validateRequired, validateType, validateMax, validateMin } from '@/components/UI/Form/Validations';
import { SmartQuery } from 'vue-apollo-decorator';
import { ALL_PROJECTS } from '@/queries/Project';
import {
  GQL_currentUnitProjects,
  GQL_currentUnitProjects_currentUnit_projects,
} from '@/queries/__generated__/currentUnitProjects';

import { ALL_DEPARTMENTS } from '@/queries/Department';
import {
  GQL_currentUnitDepartments,
  GQL_currentUnitDepartments_currentUnit_departments,
} from '@/queries/__generated__/currentUnitDepartments';
import { newOrderLineObject, setCorrectVatRateSymbolToLine, setProductToLine } from '@/app/Order';
import { ACTIVE_VAT_RATES } from '@/queries/ClientQueries';
import { makeReactiveProperty } from '@/utils/utils';
import ProductNewButton from '@/components/Product/ProductNewButton.vue';
import { GQL_order_order, GQL_order_order_orderLines } from '@/queries/__generated__/order';
import { ALL_CURRENCIES } from '@/queries/Currency';
import { GQL_allCurrencies, GQL_allCurrencies_allCurrencies } from '@/queries/__generated__/allCurrencies';
import { GQL_orderUnitSettingsDispaySettingFragments_unitSetting_unitInvoiceSetting_displaySettings } from '@/queries/__generated__/orderUnitSettingsDispaySettingFragments';
import RecurringOrderNoteHelp from '../RecurringOrder/RecurringOrderNoteHelp.vue';
import { ALL_PRODUCT_GROUPS } from '@/queries/ProductGroup';
import { GQL_currentUnitProductGroups, GQL_currentUnitProductGroups_currentUnit_productGroups } from '@/queries/__generated__/currentUnitProductGroups';

import max from 'lodash/max';
import TabTitle from '@/utils/tabtitle';
import PermissionService from '@/utils/permission-service';
import { IRules, sValidationCondition } from '@/components/UI/Form/ValidationModule';
import { productPriceAt } from '@/app/Product';
import Decimal from '@/utils/decimal';
import Bugsnag from '@bugsnag/js';
import { cloneDeep } from 'lodash';
import { ORDER_PRODUCTS_SEARCH } from './orderProductSearch';
import { GQL_productSupplierUnits, GQL_productSupplierUnits_currentUnit_productSupplierUnits } from '@/queries/__generated__/productSupplierUnits';
import { GQL_orderProductsSearch_products } from '@/queries/__generated__/orderProductsSearch';
import gql from 'graphql-tag';
import { GQL_activeNorwegianVatRates, GQL_activeNorwegianVatRates_activeNorwegianVatRates } from '@/queries/__client__/activeNorwegianVatRates';
import { ALL_CARS } from '@/queries/Car';
import { GQL_currentUnitCars, GQL_currentUnitCars_currentUnit_cars } from '@/queries/__generated__/currentUnitCars';

const PRODUCT_SUPPLIER_UNITS = gql`
  query productSupplierUnits {
   currentUnit {
      id
      productSupplierUnits {
        id
        name
      }
    }
  }
`;

const runLineRequiredValidations: sValidationCondition = ({ formElements, uid }) => {
  if (
    !formElements.orderLines.last_and_empty ||
    !formElements.orderLines.last_and_empty[uid as string]
  ) return true;
  if (
    !formElements.orderLines.product?.id ||
    !formElements.orderLines.product.id[uid as string]
  ) return true;
  if (
    !formElements.orderLines.itemName ||
    !formElements.orderLines.itemName[uid as string]
  ) return true;
  if (
    !formElements.orderLines.priceAmount ||
    !formElements.orderLines.priceAmount[uid as string]
  ) return true;
  if (
    !formElements.orderLines.quantity ||
    !formElements.orderLines.quantity[uid as string]
  ) return true;

  return !(
    formElements.orderLines.last_and_empty[uid as string].dataValue === 'true' &&
    !formElements.orderLines.product.id[uid as string].dataValue &&
    !formElements.orderLines.itemName[uid as string].dataValue &&
    (formElements.orderLines.priceAmount[uid as string].dataValue as Decimal).equals(0) &&
    (formElements.orderLines.quantity[uid as string].dataValue as Decimal).equals(1)
  );
};

@Component({
  components: {
    DocumentPage,
    OrderLine,
    CustomerInfo,
    SupplierInfo,
    OrderInfo,
    DocumentDelivery,
    DocumentHeader,
    DocumentLogo,
    LineHeader,
    OrderLineExtension,
    OrderAllowanceCharges,
    DocumentFooter,
    OrderSummary,
    ProductNewButton,
    RecurringOrderNoteHelp,
    CreditNoteInvoicePicker,
  },
})
export default class Order extends Vue {
  public PermissionService = PermissionService;
  @Prop({ type: String, default: 'show' }) public mode!: 'edit' | 'show';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Prop(Object) public data!: any;

  @Provide()
  @Prop({ type: Boolean, default: false }) public isRecurring!: boolean;

  @Provide() private get isShow() {
    return this.mode === 'show';
  }

  @Provide()
  @Prop({ type: String, default: 'order', validator: value => [ 'offer', 'order', 'orderConfirmation', 'packingSlip' ].includes(value) })
  private documentShowType!: DocumentShowType;

  @PropSync('valid', { type: Boolean, default: true }) public validFormSync!: boolean;
  @PropSync('dirty', { type: Boolean, default: false }) public dirtyFormSync!: boolean;

  @Provide() public documentComponent: Order = this;
  @Provide() public documentType = 'order';

  @SmartQuery<Order, GQL_currentUnitCars>({
    query: () => ALL_CARS,
    update: (data) => data.currentUnit.cars,
    skip() { return !this.editable },
  }) public cars!: GQL_currentUnitCars_currentUnit_cars[];

  @SmartQuery<OrderLineExtension, GQL_currentUnitProjects>({
    query: ALL_PROJECTS,
    update: data => data.currentUnit.projects,
    skip() { return !this.editable },
  }) public projects!: GQL_currentUnitProjects_currentUnit_projects[];

  @SmartQuery<OrderLineExtension, GQL_currentUnitDepartments>({
    query: ALL_DEPARTMENTS,
    update: data => data.currentUnit.departments,
    skip() { return !this.editable },
  }) public departments!: GQL_currentUnitDepartments_currentUnit_departments[];

  @SmartQuery<Order, GQL_allCurrencies>({
    query: ALL_CURRENCIES,
    update: data => data.allCurrencies,
    skip() { return !this.editable },
  }) public currencies!: GQL_allCurrencies_allCurrencies[];

  @SmartQuery<OrderLine, GQL_currentUnitProductGroups>({
    query: ALL_PRODUCT_GROUPS,
    update: data => data.currentUnit.productGroups,
    skip() { return !this.editable },
    fetchPolicy: 'no-cache',
  }) public productGroups!: GQL_currentUnitProductGroups_currentUnit_productGroups[];

  @SmartQuery<OrderLine, GQL_productSupplierUnits>({
    query: PRODUCT_SUPPLIER_UNITS,
    update: data => data.currentUnit.productSupplierUnits,
    skip() { return !this.editable },
  }) public productSupplierUnits!: GQL_productSupplierUnits_currentUnit_productSupplierUnits[];

  @SmartQuery<Order, GQL_activeNorwegianVatRates, { date: string }>({
    query: ACTIVE_VAT_RATES,
    variables() {
      return { date: this.data.order.orderDelivery.date };
    },
    skip() { return !this.editable },
    result({ data }) {
      (this.data.order as GQL_order_order).orderLines
        .filter(line => !!line.product)
        .forEach(line => {
          // Each line which has product, has VAT.
          // Since this query reruns every time the variables are changed,
          // we should set the correct VAT.
          setCorrectVatRateSymbolToLine(
            line,
            line.product,
            this.data.order,
            data.activeNorwegianVatRates,
          );
        });
    },
  }) public activeNorwegianVatRates!: GQL_activeNorwegianVatRates_activeNorwegianVatRates[];

  @Ref() public readonly orderPageRef!: DocumentPage[];
  @Ref() public readonly formRef?: SForm;
  @Ref() public readonly orderLines!: OrderLine[];

  private productPriceAt = productPriceAt;

  public rules: IRules = {
    customerParty: {
      id: [ {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: i18n.t('Document.customer') }),
      } ],
      reference: [ {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: i18n.t('Order.customerRef') }),
      } ],
    },
    date: [
      {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: i18n.t('Order.orderDate') }),
      },
      {
        validation: validateType('date'),
        message: i18n => i18n.t('GQL.Type.date'),
      },
    ],
    currencyCode: [ {
      validation: validateRequired(),
      message: i18n => i18n.t('Error.required', { field: this.t_attr('Order', 'currency') }),
    } ],
    orderDelivery: {
      date: [ {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: this.t_attr('OrderDelivery', 'date') }),
      },
      {
        validation: validateType('date'),
        message: i18n => i18n.t('GQL.Type.date'),
      } ],
      streetName: [ {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: this.t_attr('OrderDelivery', 'streetName') }),
      } ],
      city: [ {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: this.t_attr('OrderDelivery', 'city') }),
      } ],
      zip: [ {
        validation: validateRequired(),
        message: i18n => i18n.t('Error.required', { field: this.t_attr('OrderDelivery', 'zip') }),
      } ],
      country: {
        code: [ {
          validation: validateRequired(),
          message: i18n => i18n.t('Error.required', { field: this.t_attr('OrderDelivery', 'country') }),
        } ],
      },
    },
    note: [
      {
        validation: validateMin(20),
        if: () => this.isNegativeOrder,
        triggerBy: [ 'orderLines.quantity', 'orderLines.priceAmount' ],
         message: i18n => i18n.t('Error.minLength', { length: 20 }),
      },
    ],
    orderLines: {
      orderedQuantity: [], // Used for triggerBy for orderLines.quantity
      quantity: [
        {
          validation: ({ dataValue, formElements, uid }) => {
            if (
              !formElements.orderLines.orderedQuantity ||
              !formElements.orderLines.orderedQuantity[uid as string]
            ) return true;

            return dataValue.abs().lessThanOrEqualTo(formElements.orderLines.orderedQuantity[uid as string].dataValue.abs());
          },
          message: i18n => i18n.t('Error.cannotBeBigger', {
            smallerField: i18n.t('Document.delivered'),
            biggerField: i18n.t('Document.orderedLowerCase'),
          }),
          triggerBy: [ ({ withSameUID }) => withSameUID('orderLines.orderedQuantity') ],
        },
      ],
      priceAmount: [ {
        validation: validateMin(0),
        message: i18n => i18n.t('Error.cannotBeNegative', { field: i18n.t('Order.price') }),
      } ],
      product: {
        id: [
          {
            validation: validateRequired(),
            if: runLineRequiredValidations,
            message: i18n => i18n.t('Error.required', { field: i18n.t('Order.product') }),
            triggerBy: [
              ({ withSameUID }) => withSameUID('orderLines.last_and_empty'),
              ({ withSameUID }) => withSameUID('orderLines.itemName'),
              ({ withSameUID }) => withSameUID('orderLines.priceAmount'),
              ({ withSameUID }) => withSameUID('orderLines.quantity'),
            ],
          },
        ],
      },
      last_and_empty: [],
      itemName: [
        {
          validation: validateRequired(),
          if: runLineRequiredValidations,
          message: i18n => i18n.t('Error.required', { field: i18n.t('Order.productName') }),
          triggerBy: [
            ({ withSameUID }) => withSameUID('orderLines.last_and_empty'),
            ({ withSameUID }) => withSameUID('orderLines.product.id'),
            ({ withSameUID }) => withSameUID('orderLines.priceAmount'),
            ({ withSameUID }) => withSameUID('orderLines.quantity'),
          ],
        },
        {
          validation: validateMax(255),
          if: runLineRequiredValidations,
          message: i18n => i18n.t('Error.maxLength', { length: 255 }),
          triggerBy: [
            ({ withSameUID }) => withSameUID('orderLines.last_and_empty'),
            ({ withSameUID }) => withSameUID('orderLines.product.id'),
            ({ withSameUID }) => withSameUID('orderLines.priceAmount'),
            ({ withSameUID }) => withSameUID('orderLines.quantity'),
          ],
        },
      ],
    },
  };

  private ORDER_PRODUCTS_SEARCH = ORDER_PRODUCTS_SEARCH

  public mutationObserver!: MutationObserver;

  public totalPages = 1;

  public reactiveProps: {
    editable?: boolean;
  } = { editable: undefined };

  public displayLineAllowanceChargeColumn: boolean =
    this.displaySettings.invoiceLineAllowanceCharge ||
    this.notDeletedLines
      .some((line: any) => // eslint-disable-line @typescript-eslint/no-explicit-any
        line.orderLineAllowanceCharge &&
        line.orderLineAllowanceCharge.percent !== 0,
      );

  public get editable() {
    return this.mode === 'edit' && (this.data.order.isOpen || this.isRecurring);
  }

  public get isNegativeOrder() {
    const amount = this.data?.order?.payableAmount;

    if (amount.isNegative()) return true;
    return false;
  }

  public get showCreditNotePicker() {
    return this.editable && this.isNegativeOrder && !!this.data?.order?.customer?.id && this.data?.order?.note?.length === 0;
  }

  public created() {
    TabTitle.setFields({ number: this.data.order.number });
    makeReactiveProperty(this, this.reactiveProps, 'editable', 'editable');

    // If this unit doesnt use product groups, only new orders should start with 1 line
    if (
      !this.data.order.id &&
      !this.data.order.unit.unitSetting.unitInvoiceSetting.productGroups
    ) {
      this.addLine();
    }

    this.setPageNumbers();
  }

  public mounted() {
    Bugsnag.leaveBreadcrumb('Order page loaded', {orderId: this.data.order.id || 'new' });
    this.changeLinesPageNumbers();
    this.mutationObserver = new MutationObserver(this.changeLinesPageNumbers);
    this.mutationObserver.observe((this.$el.querySelector('.paginated') as HTMLElement), { childList: true });
  }

  get displaySettings(): GQL_orderUnitSettingsDispaySettingFragments_unitSetting_unitInvoiceSetting_displaySettings {
    return this.data.order.unit.unitSetting.unitInvoiceSetting.displaySettings;
  }

  public handleTab(page: number, index: number) {
    // Ignore this logic if unit has productGroups
    if (this.data.order.unit.unitSetting.unitInvoiceSetting.productGroups) return;

    const htmlPage = this.orderPageRef[page - 1].$el as HTMLElement;
    const isLastLine = index === htmlPage.querySelectorAll('.order-line').length - 1;
    if (isLastLine) this.addLine();
  }

  public addLine(product?: GQL_orderProductsSearch_products) {
    const lastPage = this.lastPageWithLines;

    const newLine = {
      ...newOrderLineObject(),
      id: undefined,
      $_page: lastPage,
    };

    if (this.data.order.car.id) {
      newLine.car = this.data.order.car;
    }

    if (this.data.order.project.id) {
      newLine.project = this.data.order.project;
    }

    if (this.data.order.department.id) {
      newLine.department = this.data.order.department;
    }

    if (product) {
      setProductToLine(
        newLine,
        product,
        this.data.order,
        this.activeNorwegianVatRates,
      );
    }

    this.data.order.orderLines.push(newLine);
    this.setLineNumbers();
    Bugsnag.leaveBreadcrumb('Line added', { line: cloneDeep(newLine) });
  }

  public get notDeletedLines() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.data.order.orderLines.filter((line: any) => !line._destroy);
  }

  public getLinesOnPage(page: number) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return this.notDeletedLines.filter((line: any) => line.$_page === page);
  }

  public get lastPageWithLines(): number {
    const pageNumbers = (this.notDeletedLines as Array<{ $_page: number }>)
      .map(line => line.$_page);
    return max(pageNumbers) || 1;
  }

  public setPageNumbers() {
    // TODO: Try to remove this function, and completely rely on changeLinesPageNumbers().
    const MAX_PER_PAGE = 25;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.data.order.orderLines.forEach((line: any) => {
      // Value doesn't matter.
      Vue.set(line, '$_page', 1);
    });
    this.totalPages = Math.ceil((this.data.order.orderLines.length || 1) / MAX_PER_PAGE);
  }

  private get isForeignCustomer(): boolean {
    return (
      this.data.order.supplierParty.country.code &&
      this.data.order.orderDelivery.country.code &&
      this.data.order.supplierParty.country.code !== this.data.order.orderDelivery.country.code
    );
  }

  public removeEmptyLines() {
    for (let i = this.notDeletedLines.length - 1; i > 0; i--) {
      const line = this.notDeletedLines[i];

      if (isLineEmpty(line)) {
        this.removeLine(line);
        Bugsnag.leaveBreadcrumb('Empty line removed');
      } else {
        break;
      }
    }
  }

  @Watch('data.order.orderLines')
  public ensureAllLinesHavePage() {
    // TODO: Try to remove this function, and completely rely on changeLinesPageNumbers().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (this.data.order.orderLines.some((line: any) => !line.$_page)) {
      this.setPageNumbers();
    }
  }

  @Watch('isForeignCustomer')
  private markAsExportWhenDeliveryCountryIsForeign(isForeign: boolean): void {
    if (isForeign && this.data.order.unit.unitSetting.unitInvoiceSetting.exports) {
      this.data.order.export = true;
    }
  }

  @Watch('data.order.export')
  @Watch('data.order.supplierParty.vatRegulation')
  private changeOrderLinesProductVatBasedOnExportAndVatRegulation(): void {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.data.order.orderLines.forEach((line: any) => {
      setCorrectVatRateSymbolToLine(line, line.product, this.data.order, this.activeNorwegianVatRates);
    });
  }

  @Watch('data.order', { deep: true })
  public changeLinesPageNumbers(mutationsList?: MutationRecord[], observer?: MutationObserver) {
    // This function listens to any change on orders object.
    // It is made to set each line to the specific page, calculated by object's heights.

    // After the change is made, it needs to be rendered first in order to be able to get heights.
    this.$nextTick(() => {
      if (observer instanceof MutationObserver) this.mutationObserver.disconnect();
      let currentPage = 1;
      let lineHeights = 0;

      // Get page dimensions.
      const orderPage = this.orderPageRef[0];
      const pageHeight = (orderPage.$el as HTMLElement).offsetHeight;
      const paddingTop = orderPage.padding;
      const paddingBottom = orderPage.padding;

      // Get add line button and order lines header.
      const addButton = this.$el.querySelector('.add-button-wrapper') as HTMLElement;
      const tableHeader = this.$el.querySelector('.paginated thead') as HTMLElement;

      // Stop looping in case neither exist. This happens when the footer is on the last page,
      // but there are no lines on that page.
      if (!addButton || !tableHeader) return;

      // Get add line and order line header dimensions.
      const addButtonHeight = addButton.offsetHeight;
      const tableHeaderHeight = tableHeader.offsetHeight;

      // Page height after padding and buttons are removed.
      const PAGE_HEIGHT = pageHeight - paddingTop - paddingBottom - addButtonHeight - tableHeaderHeight;

      let stillAvailableOnLastPage = PAGE_HEIGHT;

      // Loop through visible order lines
      this.$el.querySelectorAll('.order-line').forEach((line, index) => {
        // One htmlLine contains only the order line row, excluding extension.
        const htmlLine = line as HTMLElement;

        // Get the line extension and it's height. It might not be expanded, in which case the height is 0.
        const lineExtension = line.nextElementSibling;
        const lineExtensionHeight = lineExtension && lineExtension.classList.contains('order-line-extension')
          ? (lineExtension as HTMLElement).offsetHeight : 0;

        // Get the full extended line's height.
        const lineHeight = htmlLine.offsetHeight + lineExtensionHeight;

        // Get header and footer height.
        const header = this.$el.querySelector(`.top[data-page="${currentPage}"]`) as HTMLElement;
        const headerHeight = header ? header.offsetHeight : 0;

        // Available space is total page excluding the header and footer.
        const available = PAGE_HEIGHT - headerHeight;

        // Current line's height is added to the total height of lines on the current page.
        lineHeights += lineHeight;

        // If the total height of lines is bigger than available.
        if (lineHeights > available) {
          // Total line height on the new page is equal to current line's height.
          lineHeights = lineHeight;
          // The line should go to the next page and another page is added.
          this.totalPages = currentPage += 1;
        }

        // If this line is not deleted and exists in the array, assign the $_page number.
        if (this.notDeletedLines[index]) {
          Vue.set(this.notDeletedLines[index], '$_page', currentPage);
        }

        // These are only relevant in the last iteration through the loop.
        // Get the left available space on the last page.
        stillAvailableOnLastPage = available - lineHeights;
      });

      const footer = this.$el.querySelector('.document-footer') as HTMLElement;
      const footerHeight = footer ? footer.offsetHeight : 0;

      // If the is more available space on current page than the footer height, this is the last page.
      if (stillAvailableOnLastPage > footerHeight) {
        this.totalPages = currentPage;
      } else {
        // If not add one more page.
        this.totalPages = currentPage + 1;
      }
    });
  }

  public setLineNumbers() {
    let number = 1;

    (this.notDeletedLines as Array<{ number: number }>)
      .forEach(line => {
        line.number = number++;
      });
  }

  public removeLine(line: GQL_order_order_orderLines) {
    if (line.id) {
      Vue.set(line, '_destroy', true);
    } else {
      const index = this.data.order.orderLines.indexOf(line);
      this.data.order.orderLines.splice(index, 1);
    }
    Bugsnag.leaveBreadcrumb('Line removed');

    if (this.notDeletedLines.length < 1) {
      if (!this.data.order.unit.unitSetting.unitInvoiceSetting.productGroups) {
        this.addLine();
      }
    }

    this.setLineNumbers();
  }

  private showProductSelectTable = false;

  private get productGroupSelectOptions(): { [value: string]: string } {
    const productGroupsOptions = (this.productGroups || [])
      .reduce((obj, p) => {
        obj[p.id] = p.name;
        return obj;
      }, {} as { [value: string]: string });

    return {
      'none': this.$t('none').toString(),
      ...productGroupsOptions,
    };
  }

  private get supplierUnitSelectOptions(): { [value: string]: string } {
    return this.productSupplierUnits
      .reduce((source, supplier) => {
        if (supplier) source[supplier.id] = supplier.name;
        return source;
      }, {} as { [value: string]: string });
  }
}
